import { put, select } from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import nsToken from '@netsapiens/netsapiens-js/dist/token';

// eslint-disable-next-line import/no-cycle
import store from '../../../store';
import * as actions from '../../../state';
import { parseUrl } from '../../../utils';
import { authenticateUser } from '../../../events';

export default function* passwordReset(event) {
  yield put(actions.showLoaderPage());

  // update the URL after reset is successful, prevents re-triggering reset slow
  const appURL = yield select((state) => actions.selectConfig(state, 'appURL'));
  // const apiHash = yield select((state) => state.configs.apiHash);
  const decodedToken = nsToken.getDecoded();

  const routeParams = parseUrl(window.location);
  const username = routeParams.login;
  const newPassword = event.payload.password;

  window.history.pushState({ urlPath: appURL }, '', appURL);

  try {
    nsApi.post({
      object: 'subscriber',
      action: 'update',
      domain: decodedToken.domain,
      user: decodedToken.user,
      pwd_hash: newPassword,
    }).then(() => {
      // shunt off to authuser with user/pass
      store.dispatch(authenticateUser(username, newPassword));
    }).catch((err) => {
      console.error(err);
      store.dispatch(actions.loginFormErrorMsg('Password reset did not complete successfully.'));
      store.dispatch(actions.showPasswordResetPage());
    });
  } catch (err) {
    console.error(err);
    store.dispatch(actions.loginFormErrorMsg('Password reset did not complete successfully.'));
    store.dispatch(actions.showPasswordResetPage());
  }
}
